export default {
  methods: {
    formatAmount(amount) {
      const formAmount = this.$n(Math.abs(amount), 'currency', 'en-US');
      return amount < 0 ? `(${formAmount})` : formAmount;
    },
  },
};
